import { Rule } from '../types/rule'

export function json (schema: Rule, data: any) {
  return data
}
